import React, { useState } from 'react';
import { Modal, Input, Form } from 'antd';

const { TextArea } = Input;

const ConfirmationModal = ({
	open,
	onCancel,
	onConfirm,
	title,
	message,
	confirmText = 'Yes',
	cancelText = 'No',
	loading = false,
	showMessageInput = false,
	messagePlaceholder = '',
}) => {
	const [form] = Form.useForm();
	const [messageValue, setMessageValue] = useState('');

	const handleConfirm = () => {
		if (showMessageInput) {
			form.validateFields().then(() => {
				onConfirm(messageValue || undefined);
			});
		} else {
			onConfirm();
		}
	};

	const handleCancel = () => {
		form.resetFields();
		setMessageValue('');
		onCancel();
	};

	return (
		<Modal
			title={title}
			open={open}
			onCancel={handleCancel}
			onOk={handleConfirm}
			okText={confirmText}
			cancelText={cancelText}
			confirmLoading={loading}
			destroyOnClose>
			<Form form={form} layout="vertical">
				<p>{message}</p>
				{showMessageInput && (
					<Form.Item
						name="message"
						label="Optional Message"
						help="Enter an optional message to include in the notification">
						<TextArea
							rows={4}
							placeholder={messagePlaceholder}
							value={messageValue}
							onChange={(e) => setMessageValue(e.target.value)}
							maxLength={200}
							style={{ resize: 'none' }}
							showCount
						/>
					</Form.Item>
				)}
			</Form>
		</Modal>
	);
};

export default ConfirmationModal;

